import DocumentStats from "../components/DocumentStats";
import NeedsAttentionTable from "./home/NeedsAttentionTable";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export default function Home() {
  useDocumentTitle("Home");

  return (
    <div>
      {/* Document Stats */}
      <DocumentStats className="mb-8" />

      {/* Documents needing attention */}
      <NeedsAttentionTable />
    </div>
  );
}
